import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowStandard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.75 1.5L20.75 10.5L11.75 19.5M19.5 10.5L1.25 10.5",
		stroke: "#0A0A0A",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowStandard;
